/* eslint-disable max-len */
import { LOCALES } from 'i18n/locales';

export const termsPageIntl = {
    [LOCALES.ENGLISH]: {
        'termsPage.title': 'Terms and conditions',
        'termsPage.message.scroll': 'Please scroll to the bottom of the Terms and Conditions to Accept.'
    },
    [LOCALES.WELSH]: {
        'termsPage.title': 'Telerau ac amodau',
        'termsPage.message.scroll': 'Sgroliwch i waelod y Telerau ac Amodau i Dderbyn.'
    }
};
